import { flagshipProjects, countries } from "../data/projects";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export default function FlagshipProjects({ onOpen }) {
  // sort newest-first
  const sorted = [...flagshipProjects].sort((a, b) => (b.yearSort || 0) - (a.yearSort || 0));
  return (
    <section data-testid="flagship-projects" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div>
            <div className="overline">Flagship Projects</div>
            <h2 className="font-serif text-4xl md:text-5xl mt-3" style={{ color: "var(--primary)" }}>
              Nine projects that moved industries.
            </h2>
          </div>
          <p className="max-w-md text-sm" style={{ color: "var(--text-secondary)" }}>
            From the world&apos;s first time-block renewable product to Gigawatt-scale hybrid plants — a small selection of my highest-impact work, newest first.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px" style={{ backgroundColor: "var(--border-soft)" }}>
          {sorted.map((p, i) => (
            <motion.button
              key={p.id}
              onClick={() => onOpen?.(p.country, p.id)}
              data-testid={`flagship-card-${p.id}`}
              className="group text-left p-8"
              style={{ backgroundColor: "var(--bg)" }}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: Math.min(i * 0.04, 0.3) }}
              whileHover={{ y: -4, backgroundColor: "var(--surface)" }}
            >
              <div className="flex items-start justify-between">
                <span className="text-xs font-mono font-medium" style={{ color: "var(--text-secondary)" }}>
                  {String(i + 1).padStart(2, "0")} · {countries[p.country]?.name}
                </span>
                <motion.span
                  className="inline-flex"
                  whileHover={{ x: 2, y: -2 }}
                  style={{ color: "var(--accent-strong)" }}
                >
                  <ArrowUpRight size={16} />
                </motion.span>
              </div>

              <h3 className="mt-6 font-serif text-2xl leading-tight" style={{ color: "var(--primary)" }}>{p.name}</h3>

              <div className="mt-4 text-xs overline">{p.sector}</div>
              <div className="mt-1 text-sm font-medium" style={{ color: "var(--text-primary)" }}>{p.capacity}</div>

              <p className="mt-5 text-sm leading-relaxed line-clamp-3" style={{ color: "var(--text-secondary)" }}>
                {p.description}
              </p>

              <div className="mt-6 text-xs font-mono font-medium" style={{ color: "var(--text-secondary)" }}>{p.year}</div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
